import React from "react";
import { TouchableOpacity } from "react-native";
import styled, { withTheme } from "styled-components/native";
import Icon from "../icon/FontAwesomePro";

// Wrapper for a list row that adds the padding and any styling to the entire row
const RowWrapper = styled(TouchableOpacity)`
  ${props => props.theme.listRowStyle}

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

/**
 * Row component that calls a function when the row is pressed.
 * 
 * Props:
 * - onPress: Function that will be called when the user presses the row.
 */
const TouchableRow = ({ theme, onPress, style, children }) => (
  <RowWrapper onPress={onPress} style={style}>
    {children}

    <Icon name="chevron-right" color={theme.fontColor} iconSize={12} weight={300} style={{marginLeft: 5}} />
  </RowWrapper>
);

export default withTheme(TouchableRow);
